export const DONT_BUY = 'dont-buy';
export const IN_TEST = 'in-test';
export const NOT_TESTED = 'not-tested';



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/components/OverallScore/constants.js